import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { BrowserModule } from "@angular/platform-browser";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { AppSharedModule } from "../../shared/app-shared.module";

import { HallSweepComponent } from "./components/hall-sweep.component";
import { HallSweepActivationComponent } from "./hall-sweep-activation/hall-sweep-activation.component";
import { AddHSActivationComponent } from "./hall-sweep-activation/add-hsactivation/add-hsactivation.component";
import { EditHSActivationComponent } from "./hall-sweep-activation/edit-hsactivation/edit-hsactivation.component";
import { EmailHSActivationComponent } from "./hall-sweep-activation/email-hsactivation/email-hsactivation.component";
import { DataService_HallSweepActivation } from "./hall-sweep-activation/shared/data.service";
import { ConsequenceMaintenanceComponent } from "./consequence-maintenance/consequence-maintenance.component";
import { ConsequenceModifyComponent } from "./consequence-maintenance/consequence-modify/consequence-modify.component";
import { DataService_HallSweepConsequence } from "./consequence-maintenance/shared/data.service";
import { HallSweepSettingsComponent } from "./hall-sweep-settings/hall-sweep-settings.component";
import { DataService_HallSweepSettings } from "./hall-sweep-settings/shared/data.service";

@NgModule({
	declarations: [
		HallSweepComponent,
		HallSweepActivationComponent,
		AddHSActivationComponent,
		EditHSActivationComponent,
		EmailHSActivationComponent,
		ConsequenceMaintenanceComponent,
		ConsequenceModifyComponent,
		HallSweepSettingsComponent,
	],
	imports: [
		BrowserModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		InputTextareaModule,
		CalendarModule,
		SchoolselectorModule,
	],
	providers: [ConfirmationService, DataService_HallSweepActivation, DataService_HallSweepConsequence, DataService_HallSweepSettings],
})
export class HallSweepModule {}
